export const FlightField = {
    airline: 'airline',
    flightNumber: 'flightNumber',
    from: 'from',
    to: 'to',
    dateFrom: 'dateFrom',
    dateTo: 'dateTo',
    timeFrom: 'timeFrom',
    timeTo: 'timeTo',
};
